import {
  VStack,
  Icon,
  Text,
  Button,
} from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";

interface FinishSettingsProps {
  onClose: () => void;
}

export function FinishSettings({ onClose }: FinishSettingsProps) {
  return (
    <VStack spaceX={6} spaceY={6} py={8} align="center">
      <Icon
        as={FaCheckCircle}
        boxSize={16}
        color="green.500"
      />
      <VStack spaceX={3} spaceY={3}>
        <Text fontSize="2xl" fontWeight="bold">
          Channel Added Successfully!
        </Text>
        <Text color="gray.600" textAlign="center">
          Your WhatsApp channel has been successfully added. You can now start using it for your business communications.
        </Text>
      </VStack>
      <Button
        mt={4}
        colorScheme="green"
        onClick={onClose}
      >
        Close
      </Button>
    </VStack>
  );
} 